"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var CarouselSingleImage = function CarouselSingleImage(_ref) {
  var src = _ref.src,
    srcSet = _ref.srcSet,
    altText = _ref.altText,
    sizes = _ref.sizes,
    onLoadComplete = _ref.onLoadComplete;
  return /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: src,
    srcSet: srcSet,
    alt: altText,
    sizes: sizes,
    afterLoad: onLoadComplete
  });
};
var _default = CarouselSingleImage;
exports["default"] = _default;